import React from 'react';

export default function DomainNotFound() {

  return (
    <div className="container">
        <div className="row p-5">
            <div className="col-md-12">
                <div className="error-template">
                    <h1>
                        Oops!</h1>
                    <h2>
                        404 Not Found</h2>
                    <div className="error-details">
                        Sorry, page you are looking for is not found!
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
